import * as angular from 'angular';
import { IWidget, WidgetData } from '../../widgets';
import { IDashboardLoadService, IDashboardSeriesService } from '../../services';
import { boundWidgets } from '../../widgets/widgetTypes';

export interface IEditWidgetStateService {
    refreshSeries(item: IWidget, beginDate: string, endDate: string, referenceGroupGuid: string, dashboardGuid?: string): angular.IPromise<boolean>;
}

export class EditWidgetStateService implements IEditWidgetStateService {
    static serviceId = 'editWidgetStateService';

    static $inject = [
        '$q',
        'dashboardSeriesService',
        'dashboardLoadService'
    ];

    constructor(
        private _$q: angular.IQService,
        private _dashboardSeriesService: IDashboardSeriesService,
        private _dashboardLoadService: IDashboardLoadService
    ) {
    }

    refreshSeries(item: IWidget, beginDate: string, endDate: string, referenceGroupGuid: string, dashboardGuid?: string): angular.IPromise<boolean> {
        if (boundWidgets.indexOf(item.type) >= 0) {
            item.data = {} as WidgetData;
            return this._dashboardSeriesService.getSeries([item])
                .then(data => {
                    this._dashboardLoadService.mapWidgetList([item], data);
                    return this.refresh(item, beginDate, endDate, referenceGroupGuid, dashboardGuid);
                })
                .then(() => true);
        } else {
            return this._$q.when<boolean>(false);
        }
    }

    private refresh(item: IWidget, beginDate: string, endDate: string, referenceGroupGuid: string, dashboardGuid?: string) {
        const widgets = [item];
        return this._dashboardLoadService
            .refresh(widgets, beginDate, endDate, referenceGroupGuid, false, dashboardGuid, true)
            .then(data => {
                this._dashboardLoadService.assignValues(data, widgets);
            });
    }
}